<template>
  <div class="logos-item">
    <div v-if="svg" class="logos-item__wrapper" v-html="svg" />
    <div v-else class="logos-item__wrapper">
      <img :src="item.logo" :alt="`The logo of ${ item.name || 'one of our clients' }`" />
    </div>
    <p v-if="item.name" class="logos-item__name">{{ item.name }}</p>
  </div>
</template>

<script>
export default {
  name: "LogosItem",

  props: {
    item: Object
  },

  data() {
    return {
      svg: ''
    };
  },

  created() {
    if (this.item.logo.includes("svg")) {
      this.svg = require(`./../assets${this.item.logo}`);
    }
  },

  mounted() {}
};
</script>

<style lang="scss">
@import "../scss/globals.scss";

.logos-item {
  background: #181818;
  position: relative;

  // &:hover {
  //   .logos-item__wrapper {
  //     opacity: .1;
  //   }

  //   .logos-item__name {
  //     opacity: 1;
  //     transform: translate(-50%, -50%);
  //   }
  // }

  &__wrapper {
    transition: opacity .2s;
    height: 100%;

    box-sizing: border-box;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__name {
    transition: all .2s;
    opacity: 0;
    transform: translate(-50%, -55%) scale(0.9);
    @include typeset(display-1);
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 1;
    pointer-events: none;
  }

  img {
    max-width: 100%;
    max-height: 100%;
  }

  svg {
    width: 100%;
    height: 100%;

    * {
      fill: #7c7c7c;
      stroke: #181818;
    }
  }
}
</style>
